"use client"

import { motion, useScroll, useTransform } from "motion/react"
import { useRef } from "react"
import './life.css';

export default function ScrollHorizontal() {
    const containerRef = useRef(null)
    const { scrollYProgress } = useScroll({
        target: containerRef,
        offset: ["start start", "end end"],
    })

    const totalDistance = (items.length - 1) * (ITEM_WIDTH + GAP)
    const x = useTransform(scrollYProgress, [0, 1], [0, -totalDistance])

    return (
        <div id="example">
            <section className="intro-section">
                <h3>The Fading Flame</h3>
            </section>

            <div ref={containerRef} className="scroll-container">
                <div className="sticky-wrapper">
                    <motion.div className="gallery" style={{ x }}>
                        {items.map((item) => (
                            <div
                                key={item.id}
                                className="gallery-item"
                                style={
                                    {
                                        backgroundImage: `url(${item.image})`,
                                    }
                                }
                            >
                                <div className="item-content">
                                    <h5>{item.label}</h5>
                                </div>
                            </div>
                        ))}
                    </motion.div>
                </div>
            </div>
        </div>
    )
}


/**
 * ==============   Data   ================
 */

const items = [
    { label: "1809: Born in Boston", image: "../../assets/imgs/candle1.png" },
    { label: "1827: First published poems", image: "../../assets/imgs/candle2.png" },
    { label: "1839: Shaping gothic storytelling", image: "../../assets/imgs/candle3.png" },
    { label: "1845: Publication of The Raven", image: "../../assets/imgs/candle4.png" },
    { label: "1849: Dies in Baltimore", image: "../../assets/imgs/candle5.png" },
]

const ITEM_WIDTH = 400
const GAP = 30
